import PropTypes from "prop-types";
import classnamesBind from "classnames/bind";
import styles from "./SubRatingsv2.scss";
import RatingBar from "../../ratingBar/v2/RatingBarv2";

const classnames = classnamesBind.bind(styles);

export default function SubRatings({ subRatings, additionalClasses }) {
  if (subRatings.length === 0) {
    return null;
  }

  return (
    <div className={classnames(additionalClasses)}>
      {subRatings.map(
        ({ id, label, minLabel, midLabel, maxLabel, percentage }) => (
          <div key={id} className={styles.subRating}>
            <RatingBar
              id={id}
              label={label}
              minLabel={minLabel}
              midLabel={midLabel}
              maxLabel={maxLabel}
              percentage={percentage}
            />
          </div>
        )
      )}
    </div>
  );
}

SubRatings.propTypes = {
  subRatings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      minLabel: PropTypes.string.isRequired,
      midLabel: PropTypes.string.isRequired,
      maxLabel: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  additionalClasses: PropTypes.string,
};
